import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";
import dayjs from "dayjs";

function getCartTotal(state) {
  let intTotal = 0;

  for (let i = 0; i < state.arrBets.length; i++) {
    let objBet = state.arrBets[i].objBet;

    if (!objBet) {
      console.error("Invalid bet at index", i, state.arrBets[i]);
      continue;
    }

    let intNumDraws = parseInt(objBet.intNumDraws || 0);
    let intStakeAmount = parseInt(objBet.intStakeAmount || 0);
    let intLines = objBet.arrLines?.length || 0;

    intTotal += intLines * intStakeAmount * intNumDraws;
  }

  return intTotal;
}

function emitCartUpdate(state) {
  //console.log("emitting");

  //console.log("state is ", state);
  //console.log("carttotal is");

  let intCartTotal = getCartTotal(state);

  Vue.prototype.$utils.emitWCEvent2(Vue.prototype.$root, "cartUpdate", {
    intNumItems: state.arrBets.length,
    intCartTotal,
  });
}

function emitUserInfo(state) {
  // In widget mode, user info comes from 3rd party - use what we have
  const blnWidgetMode = Vue.prototype.$blnWidgetMode;

  let strBalance = "";
  let strPendingWithdrwal = "";
  let strMobile = "";
  let strAvatarUrl = "";
  let strName = "";

  if (state.objUserProfile) {
    strMobile = state.objUserProfile.mobile || "";
    strName = state.objUserProfile.first_name || "";
    strAvatarUrl =
      Vue.prototype.$utils.getAvatarFileName(state.objUserProfile) || "";
  }

  if (state.objWalletStats) {
    strBalance = state.objWalletStats.fltEffectiveBalance || 0;
  }

  let objUserInfo = {
    strBalance,
    strMobile,
    strPendingWithdrwal,
    strAvatarUrl,
    strName,
    blnWidgetMode,
  };

  // console.log("[Store] emitUserInfo:", objUserInfo);

  // this.$utils.emitWCEvent2(this, "userInfo", objUserInfo);
  Vue.prototype.$utils.emitWCEvent2(
    Vue.prototype.$root,
    "userInfo",
    objUserInfo,
  );
}

function emitState(state) {
  emitUserInfo(state);
}

function getLottoModel(strLottoId) {
  let obj = {
    strLottoId: strLottoId,
    arrLines: [
      {
        arrNumbers: [],
      },
    ],
  };

  return obj;
}

export default new Vuex.Store({
  plugins: [createPersistedState()],

  state: {
    blnLoading: false,
    objBrandingSettings: {},
    arrLottos: [],
    arrLottoConfigs: [],

    objSignInData: { objUser: {}, strToken: "" },
    objWalletStats: {},
    objUserProfile: {},
    objCredentials: {},
    intNumDraws: 1,
    intStakeAmount: 10,
    arrBets: [],
    objBet: null,
    lottoStyle: {},
  },
  getters: {
    objUserProfile: (state) => {
      try {
        return state.objUserProfile;
      } catch (e) {
        console.log(e);
      }
      return {};
    },
    arrLottoConfigs: (state) => {
      try {
        return state.arrLottoConfigs;
      } catch (e) {
        console.log(e);
      }
      return [];
    },
    arrLottos: (state) => {
      try {
        return state.arrLottos;
      } catch (e) {
        console.log(e);
      }
      return [];
    },

    getLottoConfig: (state) => (strLottoId) => {
      // Find lotto config from dynamically loaded configs (no hardcoded data)
      let objLottoConfig = state.arrLottoConfigs.find(
        (obj) => obj.strLottoId == strLottoId,
      );

      return objLottoConfig;
    },

    strToken: (state) => {
      try {
        return state.objSignInData.strToken;
      } catch (e) {
        console.log(e);
      }
      return "";
    },
    objUser: (state) => {
      try {
        return state.objUserProfile;
      } catch (e) {
        console.log(e);
      }
      return {};
    },
    blnIsUserLoggedIn: (state) => {
      let strToken = localStorage.getItem("t");

      if (strToken) {
        return true;
      }

      return false;
      try {
        if (state.objSignInData.objUser.player_id) {
          return true;
        }
      } catch (e) {
        console.log(e);
      }
      return false;
    },
    fltCartValue: (state) => {
      return getCartTotal(state);
    },
    objWalletStats: (state) => {
      try {
        return state.objWalletStats;
      } catch (e) {
        console.log(e);
      }
      return "";
    },
    intCartTotal: (state, getters) => {
      return getCartTotal(state);
    },
    intCartItems: (state, getters) => {
      return state.arrBets.length;
    },
    objCredentials: (state) => {
      try {
        return state.objCredentials;
      } catch (e) {
        console.log(e);
      }
      return {};
    },
    arrBets: (state) => {
      try {
        return state.arrBets;
      } catch (e) {
        console.log(e);
      }
      return [];
    },
    objBet: (state) => {
      try {
        return state.objBet;
      } catch (e) {
        console.log(e);
      }
      return null;
    },
    arrCompletedBets: (state) => {
      try {
        //only return non pending
        let arr = [];
        let arrBets = state.arrBets;

        for (let i = 0; i < arrBets.length; i++) {
          let objBet = arrBets[i];
          objBet.intIndex = i;
          if (objBet.strStatus == "completed") {
            arr.push(objBet);
          }
        }
        return arr;
      } catch (e) {
        console.log(e);
      }
      return [];
    },
    objBrandingSettings: (state) => {
      return state.objBrandingSettings;
    },
    initialLines(state) {
      return Math.min(Math.max(state.lottoStyle.initial_lines ?? 12, 1), 20);
    },
    lottoStyle(state) {
      return state.lottoStyle;
    },
  },

  mutations: {
    emitState(state) {
      emitCartUpdate(state);
      emitUserInfo(state);
    },
    startBatchUpdate(state) {
      state._batchUpdate = true;
    },
    endBatchUpdate(state) {
      state._batchUpdate = false;
      emitState(state);
    },
    resetState(state) {
      state.objSignInData = { objUser: {}, strToken: "" };
      emitCartUpdate(state);
    },
    signIn(state, objSignInData) {
      try {
        // console.log(objSignInData);

        let { objUser, strToken } = objSignInData;

        state.objSignInData.objUser = objUser;
        state.objSignInData.strToken = strToken;
        // Only emit if not in batch update mode
        if (!state._batchUpdate) emitState(state);
      } catch (e) {
        console.log(e);
      }
    },
    emptyCart(state) {
      try {
        state.arrBets = [];
      } catch (e) {
        console.log(e);
      }
    },

    deleteLine(state, { intLineIndex }) {
      try {
        let objBet = state.objBet;
        let { arrLines } = objBet;
        arrLines.splice(intLineIndex, 1);
        emitCartUpdate(state);
      } catch (e) {
        console.log(e);
      }
    },

    deleteBet(state, intIndex) {
      try {
        state.arrBets.splice(intIndex, 1);
        emitCartUpdate(state);
      } catch (e) {
        console.log(e);
      }
    },

    wipeExpiredBets(state) {
      try {
        let objNow = dayjs();
        let intBefore = state.arrBets.length;

        state.arrBets = state.arrBets.filter((objBet) => {
          let strCloseDateTime = objBet && objBet.strCloseDateTime;
          if (!strCloseDateTime) return true;

          let objCloseDateTime = dayjs(strCloseDateTime);
          if (!objCloseDateTime.isValid()) return true;
 
          return !objNow.isAfter(objCloseDateTime);
        });

        if (state.arrBets.length !== intBefore) {
          emitCartUpdate(state);
        }
      } catch (e) {
        console.log(e);
      }
    },

    setNumbers(state, { intBetIndex, intLineIndex, intPoolIndex, arrNumbers }) {
      try {
        let objBet = state.arrBets[intBetIndex];
        let objLine = objBet.arrLines[intLineIndex];
        let objPool = objLine.arrPools[intPoolIndex];
        objPool.arrNumbers = arrNumbers;
      } catch (e) {
        console.log("pool number is", intPoolIndex);
        console.log(e);
      }
    },

    addBet(state, objBet) {
      try {
        //status is added
        objBet.blnExpand = false;

        state.arrBets.push(objBet);
      } catch (e) {
        console.log(e);
      }
    },
    setBet(state, objBet) {
      try {
        // console.log("set bet", objBet);
        //status is added
        objBet.blnExpand = false;
        state.objBet = objBet;
      } catch (e) {
        console.log(e);
      }
    },
    updateBet(state, { intBetIndex, objBet }) {
      try {
        state.arrBets[intBetIndex] = objBet;
        emitCartUpdate(state);
      } catch (e) {
        console.log(e);
      }
    },
    setBetStatus(state, { strStatus }) {
      try {
        state.objBet.strStatus = strStatus;
      } catch (e) {
        console.log(e);
      }
    },

    emptyCart(state) {
      try {
        state.objLottos = {};
        state.arrBets = [];
        state.objBet = null;
        emitCartUpdate(state);
        emitState(state);
      } catch (e) {
        console.log(e);
      }
    },
    logout(state) {
      try {
        // alert(state.objSignInData.strToken)

        localStorage.removeItem("t");
        state.objSignInData = { objUser: {} };
        state.objSignInData.strToken = "";
        emitState(state);
      } catch (e) {
        console.log(e);
      }
    },
    setWalletStats(state, objWalletStats) {
      try {
        state.objWalletStats = objWalletStats;
      } catch (e) {
        console.log(e);
      }
      // Only emit if not in batch update mode
      if (!state._batchUpdate) emitState(state);
    },
    setUserProfile(state, objUserProfile) {
      try {
        state.objUserProfile = objUserProfile;
      } catch (e) {
        console.log(e);
      }
      // Only emit if not in batch update mode
      if (!state._batchUpdate) emitState(state);
    },

    setCredentials(state, objCredentials) {
      try {
        state.objCredentials = objCredentials;
      } catch (e) {
        console.log(e);
      }
    },

    setLottoConfigs(state, arrLottoConfigs) {
      try {
        state.arrLottoConfigs = arrLottoConfigs;
      } catch (e) {
        console.log(e);
      }
    },
    setAvatar(state, strFileName) {
      try {
        state.objSignInData.objUser.avatar_filename = strFileName;
      } catch (e) {
        console.log(e);
      }
      emitState(state);
    },

    setLottos(state, arrLottos) {
      try {
        state.arrLottos = arrLottos;
      } catch (e) {
        console.log(e);
      }
    },

    setBrandingSettings(state, objBrandingSettings) {
      try {
        state.objBrandingSettings = objBrandingSettings;
      } catch (e) {
        console.log(e);
      }
    },

    applyLottoStyle(state, objStyle = {}) {
      try {
        const isDefined = (v) => v !== undefined && v !== null;

        const style = {
          initial_lines: objStyle.initial_lines ?? 12,

          colors: {
            numberColor: "#212121",
            numberPickedColor: "#ffffff",
            numberBg: "#ffffff",
            pickerBodyBg: "#ffffff",
            buttonBg: "#212121",
            buttonColor: "#ffffff",
            pickerSvgColor: "#bc000c",
            lineNumberColor: "#000000",
            ...(objStyle.colors || {}),
          },

          spacing: {
            numberPadding: {
              topBottom: 6,
              rightLeft: 6,
              ...(objStyle.spacing?.numberPadding || {}),
            },
            numberMargin: {
              topBottom: 3,
              rightLeft: 3,
              ...(objStyle.spacing?.numberMargin || {}),
            },
            pickerPadding: {
              topBottom: 20,
              rightLeft: 20,
              ...(objStyle.spacing?.pickerPadding || {}),
            },
            pickerMargin: {
              topBottom: 0,
              rightLeft: 5,
              ...(objStyle.spacing?.pickerMargin || {}),
            },
            buttonPadding: {
              topBottom: 8,
              rightLeft: 6,
              ...(objStyle.spacing?.buttonPadding || {}),
            },
            buttonMargin: {
              topBottom: 0,
              rightLeft: 8,
              ...(objStyle.spacing?.buttonMargin || {}),
            },
          },

          fonts: {
            numberSize: isDefined(objStyle.fonts?.numberSize)
              ? objStyle.fonts.numberSize
              : 15,
            buttonSize: isDefined(objStyle.fonts?.buttonSize)
              ? objStyle.fonts.buttonSize
              : 14,
            lineNumberSize: isDefined(objStyle.fonts?.lineNumberSize)
              ? objStyle.fonts.lineNumberSize
              : 10,
          },

          borderRadius: {
            number: isDefined(objStyle.borderRadius?.number)
              ? objStyle.borderRadius.number
              : 10,
            picker: isDefined(objStyle.borderRadius?.picker)
              ? objStyle.borderRadius.picker
              : 20,
            button: isDefined(objStyle.borderRadius?.button)
              ? objStyle.borderRadius.button
              : 30,
          },

          sizes: {
            numberWidth: isDefined(objStyle.sizes?.numberWidth)
              ? objStyle.sizes.numberWidth
              : 34,
            numberHeight: isDefined(objStyle.sizes?.numberHeight)
              ? objStyle.sizes.numberHeight
              : 34,
          },

          customCss: objStyle.customCss || "",

          // Chance options for picker (e.g., [3, 4, 5] allows user to pick 3, 4, or 5 numbers)
          arrChances: Array.isArray(objStyle.arrChances)
            ? objStyle.arrChances
            : [],
        };

        style.layout = { breakpoints: objStyle.layout?.breakpoints || {} };

        state.lottoStyle = style;

        const root = document.documentElement;

        Object.entries(style.colors).forEach(([key, val]) => {
          if (isDefined(val) && val !== "") {
            root.style.setProperty(
              "--lotto-" +
                key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(),
              val,
            );
          }
        });

        const spacing = (g, n) => {
          if (!g) return;
          if (isDefined(g.topBottom))
            root.style.setProperty(`--lotto-${n}-tb`, `${g.topBottom}px`);
          if (isDefined(g.rightLeft))
            root.style.setProperty(`--lotto-${n}-rl`, `${g.rightLeft}px`);
        };

        spacing(style.spacing.numberPadding, "number-padding");
        spacing(style.spacing.numberMargin, "number-margin");
        spacing(style.spacing.pickerPadding, "picker-padding");
        spacing(style.spacing.pickerMargin, "picker-margin");
        spacing(style.spacing.buttonPadding, "button-padding");
        spacing(style.spacing.buttonMargin, "button-margin");

        root.style.setProperty(
          "--lotto-number-font-size",
          `${style.fonts.numberSize}px`,
        );
        root.style.setProperty(
          "--lotto-button-font-size",
          `${style.fonts.buttonSize}px`,
        );
        root.style.setProperty(
          "--lotto-line-number-font-size",
          `${style.fonts.lineNumberSize}em`,
        );

        root.style.setProperty(
          "--lotto-number-border-radius",
          `${style.borderRadius.number}px`,
        );
        root.style.setProperty(
          "--lotto-picker-border-radius",
          `${style.borderRadius.picker}px`,
        );
        root.style.setProperty(
          "--lotto-button-border-radius",
          `${style.borderRadius.button}px`,
        );

        root.style.setProperty(
          "--lotto-number-width",
          `${style.sizes.numberWidth}px`,
        );
        root.style.setProperty(
          "--lotto-number-height",
          `${style.sizes.numberHeight}px`,
        );

        let el = document.getElementById("lotto-custom-styles");
        if (style.customCss && style.customCss.trim()) {
          if (!el) {
            el = document.createElement("style");
            el.id = "lotto-custom-styles";
            document.head.appendChild(el);
          }
          el.textContent = style.customCss;
        } else if (el) {
          el.remove();
        }
      } catch (e) {
        console.error("applyLottoStyle error:", e);
      }
    },
  },
  actions: {},
  modules: {},
});
